/*
 * Minimal Shopify AJAX-cart shim for the Potholder Design Wizard.
 *
 * The wizard was written against the legacy shopify_common.js helpers
 * (Shopify.addItem / Shopify.queue / Shopify.moveAlong), which this
 * jQuery-free theme does not ship. We provide just enough, using the
 * standard /cart/add.js endpoint (works on every Shopify store).
 *
 * Note: the wizard redefines Shopify.moveAlong itself at runtime, so we
 * only need addItem + queue here. Definitions are guarded so we never
 * clobber anything the platform already provides.
 */
(function () {
  window.Shopify = window.Shopify || {};

  if (typeof window.Shopify.queue === 'undefined') {
    window.Shopify.queue = [];
  }

  if (typeof window.Shopify.addItem !== 'function') {
    window.Shopify.addItem = function (variantId, quantity, callback) {
      var qty = parseInt(quantity, 10);
      if (isNaN(qty) || qty < 1) {
        qty = 1;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (response) {
          return response.json().catch(function () {
            return null;
          });
        })
        .then(function () {
          if (typeof callback === 'function') {
            callback();
          }
        })
        .catch(function () {
          // Fail soft: keep the wizard's queue moving even if one add fails
          // (e.g. a stale variant id) so the rest of the design still adds.
          if (typeof callback === 'function') {
            callback();
          }
        });
    };
  }
})();
